import { AlertServiceService } from './../services/alertservice/alert-service.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuardGuard implements CanActivate {
  roles: string[] = [];

  constructor(private router: Router,
    private alertService: AlertServiceService) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    if (route && route.data && route.data.roles) {
      this.roles = route.data.roles;
    }

    if (localStorage.getItem('AlghanimCurrentUser') !== null) {
      const ROLES: string[] = JSON.parse(localStorage.getItem('AlghanimCurrentUser')).data.roles;

      if (this.checkRoles) {
        if (state.url == '/') {
          if (ROLES.includes('Admin')) {
            this.router.navigate(['/admin']);
            return false;
          }
          else if ((ROLES.includes("Supervisor"))) {
            this.router.navigate(['/supervisor']);
            return false;
          }
          else if ((ROLES.includes("Engineer"))) {
            this.router.navigate(['/contracts/list']);
            return false;
          }
          else if ((ROLES.includes("Foreman"))) {
            this.router.navigate(['/foreman']);
            return false;
          }
          else if ((ROLES.includes('Dispatcher') || ROLES.includes('MovementController'))) {
            this.router.navigate(['/dispatcher']);
            return false;
          }
          else if ((ROLES.includes("Call Center"))) {
            this.router.navigate(['/customer/customersearch']);
            return false;
          }
          else if ((ROLES.includes("Supervisor CallCenter"))) {
            this.router.navigate(['/customer/customersearch']);
            return false;
          }
          else if ((ROLES.includes("Finance"))) {
            this.router.navigate(['/contracts/list']);
            return false;
          }
          else if ((ROLES.includes("ContractAdministrator"))) {
            this.router.navigate(['/contracts/list']);
            return false;
          }
        }
        return true;
      }
      else {
        if (state.url == '/') {
          if (ROLES.includes('Admin')) {
            this.router.navigate(['/admin']);
            return false;
          }
          else if ((ROLES.includes("Supervisor"))) {
            this.router.navigate(['/supervisor']);
            return false;
          }
          else if ((ROLES.includes("Engineer"))) {
            this.router.navigate(['/contracts/list']);
            return false;
          }
          else if ((ROLES.includes("Foreman"))) {
            this.router.navigate(['/foreman']);
            return false;
          }
          // else if ((ROLES.includes("ContractAdministrator"))) {
          //   this.router.navigate(['/contractAdministrator']);
          //   return false;
          // }

          else if ((ROLES.includes('Dispatcher') || ROLES.includes('MovementController'))) {
            this.router.navigate(['/dispatcher']);
            return false;
          }
          else if ((ROLES.includes("Call Center"))) {
            this.router.navigate(['/customer/customersearch']);
            return false;
          }
          else if ((ROLES.includes("Supervisor CallCenter"))) {
            this.router.navigate(['/customer/customersearch']);
            return false;
          }
          else if ((ROLES.includes("Finance"))) {
            this.router.navigate(['/contracts/list']);
            return false;
          }
          else if ((ROLES.includes("ContractAdministrator"))) {
            this.router.navigate(['/contracts/list']);
            return false;
          }
        }
        else {
          this.alertService.error('You don\'t have permission to Access');
          this.router.navigate(['/']);
          return false;
        }
      }
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  get checkRoles(): boolean {
    const ROLES: string[] = JSON.parse(localStorage.getItem('AlghanimCurrentUser')).data.roles;
    for (let i = 0; i < this.roles.length; i++) {
      for (let j = 0; j < ROLES.length; j++) {
        if (this.roles[i].toLowerCase() == ROLES[j].toLowerCase()) {
          return true;
        }
      }
    }

    return false;
  }
}
